import React from 'react';

import { FormSection } from '../../../../common/components/Form/Form';
import { LockedInput } from '../../../../common/components/Form/FormLockedInput';
import { DateInput } from '../../../../common/components/Form/FormDateInput';
import { Notice, NoticeText, NoticeThinText } from '../../../../common/components/Notice';
import Exclude from '../../../../roleBasedAccess/Exclude';
import { BlocHForm } from './BlocHForm';

export const BlocHTab1 = props => (
  <BlocHForm {...props}>
    {(formik, { hasHbCompanyTracking }) => (
      <Exclude
        exclude="folder:bloc_h:tab_1:form_section_1:read"
        no={() => (
          <FormSection title="Suivi de réalisation">
            {hasHbCompanyTracking && (
              <Notice variant="info" mb="2rem" spacing="1rem">
                <NoticeText variant="info">
                  Les entreprises renseignent leurs dates de début et de fin de projet dans « Suivi
                  des entreprises ».
                </NoticeText>
                <NoticeThinText>
                  Lorsque toutes les ont renseignées, la date de début la plus ancienne et la date
                  de fin la plus récente sont reprises ici. Vous pouvez aussi les saisir à la main.
                </NoticeThinText>
              </Notice>
            )}

            <DateInput
              label="Date de début de projet"
              name="projectLaunchInfosReceivedAt"
              id="projectLaunchInfosReceivedAt"
            />

            <LockedInput
              defaultIsLocked={!!formik.values.projectEndFeedbackRequestSentAt}
              left="37%"
            >
              <DateInput
                label="Dernière date d'envoi de demande de retour pour fin de projet"
                name="projectEndFeedbackRequestSentAt"
                id="projectEndFeedbackRequestSentAt"
                disabled={!formik.values.projectLaunchInfosReceivedAt}
              />
            </LockedInput>

            <Notice variant="info" mb="2rem" spacing="1rem">
              <NoticeText variant="info">
                Documents à envoyer à la personne à contacter :
              </NoticeText>
              <NoticeThinText>
                Si nécessaire, consulter les fiches-procédures ou l'administrateur
              </NoticeThinText>
            </Notice>

            <DateInput
              label="Date de fin de projet"
              name="projectEndReceivedAt"
              id="projectEndReceivedAt"
              disabled={!hasHbCompanyTracking && !formik.values.projectEndFeedbackRequestSentAt}
            />
          </FormSection>
        )}
      />
    )}
  </BlocHForm>
);
